import * as React from 'react'
import { TeamOwnerActionList } from './TeamOwnerActionList'
import { Provider } from 'react-redux'
import { mockState, createMockStore } from 'mockState'

export const TeamOwnerActionListExamples = () => {
  return (
    <div className="TeamOwnerActionListExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <TeamOwnerActionList />
      </Provider>
    </div>
  )
}
